import measurePerformance, { PerformanceMetric } from '../util/measurePerformance';

import RestClient from './RestClient';
import { AvailableProductsResponse } from './sites/model';

class AvailableProductsClient extends RestClient {
  constructor() {
    super({
      baseUrl: '/gateway/api/app-switcher',
    });
  }

  async getAvailableProducts({ retryMS }: { retryMS: number[] }): Promise<AvailableProductsResponse> {
    return measurePerformance(
      PerformanceMetric.AvailableProductsService,
      () => this.getResource<AvailableProductsResponse>('/api/available-products'),
      retryMS,
    );
  }
}

export default new AvailableProductsClient();
